<template>
  <transition name="slide" @after-leave="$emit('back')">
    <div v-show="isShown" class="nav-overlay-compact-screen">
      <div v-if="breadcrumb" class="nav-overlay-compact-screen__breadcrumb" @click="isShown = false">
        <svg
          class="nav-overlay-compact-screen__breadcrumb-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.67 3.87001L15.9 2.10001L6 12L15.9 21.9L17.67 20.13L9.54 12L17.67 3.87001Z" fill="white" />
        </svg>
        <div class="nav-overlay-compact-screen__breadcrumb-text" v-html="breadcrumb" />
      </div>
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NavOverlayCompactScreen',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    breadcrumb: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isShown: this.isVisible,
    };
  },
  watch: {
    isVisible(val) {
      this.isShown = val;
    },
  },
};
</script>

<style scoped lang="scss">
.nav-overlay-compact-screen {
  @apply bg-gray-100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  &:first-child {
    z-index: 0; // needed for proper layering
  }

  /* Screen Transition ------------------- */
  &.slide-enter-active,
  &.slide-leave-active {
    transition: transform 0.5s cubic-bezier(0, 1, 0.3, 1);
  }
  &.slide-enter,
  &.slide-leave-to {
    transform: translate3d(100%, 0, 0);
  }

  /* Breadcrumb ------------------------------ */
  &__breadcrumb {
    @apply p-2;
    @apply pt-3;
    display: flex;
    align-items: center;
    cursor: pointer;

    &-icon {
      path {
        fill: var(--nav-highlight-color);
      }
    }

    &-text {
      @apply ml-2;
      @apply text-xl;
      @apply text-left;
      @apply text-white;
      @apply font-heading;
      @apply leading-normal;
    }
  }
}
</style>
